/** Angular 22 keeps CSR listeners in its replay map after the initial replay.
 * Release only nodes whose view Angular is destroying; never clear live/deferred blocks.
 * Kept separate so the private-token adapter can be removed after an upstream fix.
 */
export function releaseReplayNode(
  blocks: Map<string, Set<Element>>,
  node: { getAttribute?: (name: string) => string | null },
): void {
  const block = node?.getAttribute?.('ngb') || '';
  blocks.get(block)?.delete(node as Element);
}

/** Renderer2.destroyNode receives view roots, not every descendant listener. */
export function releaseReplaySubtree(blocks: Map<string, Set<Element>>, root: Element): void {
  releaseReplayNode(blocks, root);
  root?.querySelectorAll?.('*').forEach(node => releaseReplayNode(blocks, node));
}
